<template>
  <div class="information texture-bg-css">
    <Top></Top>
    <Storage></Storage>
    <Storehouse></Storehouse>
  </div>
</template>

<script>
import Top from '@/components/information/Top'
import Storage from '@/components/information/Storage'
import Storehouse from '@/components/information/Storehouse'

export default {
  name: 'Information',
  components: {
    Top,
    Storage,
    Storehouse
  },
  mixins: [],
  data() {
    return {}
  },
  mounted: function() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
